import * as React from "react";
import { cn } from "@/lib/utils";

interface InputGroupItemProps extends React.ComponentProps<"input"> {
  inlineLabel?: string;
  labelWidth?: string;
}

function InputGroupItem({ 
  className, 
  type, 
  inlineLabel, 
  labelWidth = "120px",
  style,
  ...props 
}: InputGroupItemProps) {
  return (
    <div className="relative flex items-center">
      {inlineLabel && (
        <div 
          className="absolute left-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-sm font-normal"
          style={{ width: labelWidth }}
        >
          {inlineLabel}
        </div>
      )}
      <input
        type={type}
        data-slot="input"
        className={cn(
          "w-full h-12 bg-transparent text-base font-normal transition-colors",
          "placeholder:text-muted-foreground",
          "focus:outline-none",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          "md:text-sm pr-4",
          className
        )}
        style={{ paddingLeft: inlineLabel ? `calc(${labelWidth} + 1.07rem)` : '1.07rem', ...style }}
        {...props}
      />
    </div>
  );
}

interface InputGroupProps {
  children: React.ReactNode;
  className?: string;
}

function InputGroup({ children, className }: InputGroupProps) {
  const childArray = React.Children.toArray(children);
  
  return (
    <div 
      className={cn(
        "rounded-3xl p-0.5 bg-input-bg border border-control-border overflow-hidden shadow-lg",
        className
      )}
    >
      {childArray.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < childArray.length - 1 && (
            <div className="h-px bg-divider mx-4" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export { InputGroup, InputGroupItem };

